export const DRAWER_WIDTH = 240;
export const DRAWER_COLLAPSED_WIDTH = 64;
export const CONTENT_MIN_WIDTH = 800;
export const DRAWER_Z_INDEX = 1200;
export const NAVBAR_Z_INDEX = 1201;

export const layoutStylesFn = (drawerWidth) => ({
    minHeight: '100vh',
    '@supports (height: 100dvh)': {
        minHeight: '100dvh',
    },
    [`@media (max-width: ${CONTENT_MIN_WIDTH + drawerWidth}px)`]: {
        overflowX: 'auto',
    },
});
